import axios from "axios";
import Modal from "react-modal";
import "../../../../components/TimeTracker/TimeTrackerProject/TimeTrackerProject.css";
import "rsuite/dist/rsuite.min.css";
import { toast } from "react-toastify";
import { AES, enc } from 'crypto-js';
import "react-toastify/dist/ReactToastify.css";
import { useParams, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { useSelector, useDispatch } from 'react-redux';
import Select from "react-select";
import Close from "../../../../images/icons/black-close.svg";
import PlusIcon from "../../../../images/icons/plus-icon.svg";
import React, { useState, useEffect, useRef } from "react";
import { DateRangePicker } from 'rsuite';
import Tick from "../../../../images/singleinvoice/tick-green.svg";
import crssrImage from "../../../../images/singleinvoice/cross-red.svg";
import { setProjectAdded } from "../../../../features/projects/projectSlice.js";
import { useFetchClientProjectManager } from "../../../../components/TimeTracker/TimeTrackerProject/useProjectDetails.jsx";
import { useFetchClientDetails } from "../../../../components/TimeTracker/TimeTrackerClient/useClientDetails.jsx";
import ProjectAlerts from "../../../../components/Clients/ClientProject/ProjectAlert.jsx";
import { useGetTeams } from "../../../../components/TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import userType from "../../../../constants/userType.js";
import "./MvpNewProjectModal.css";


const NewProjectsModal = ({ hideButton = false, openSignal = 0, lockedClientId = "" }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [clientDropdownOpen, setClientDropdownOpen] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [clientId, setClientId] = useState(lockedClientId || "");
  const [discription, setDiscription] = useState("");
  const [billable, setBillable] = useState(true);
  const [timeLoading, setTimeLoading] = useState(false);
  const [budgetLoading, setBudgetLoading] = useState(false);
  const [timeChecked, setTimeChecked] = useState(false);
  const [budgetChecked, setBudgetChecked] = useState(false);
  const [timeThreshold, setTimeThreshold] = useState(0);
  const [budgetThreshold, setBudgetThreshold] = useState(0);

  const [selectedTimeThresholdTeamsEdit, setSelectedTimeThresholdTeamsEdit] = useState([]);
  const [selectTimeThresholdAllTeam, setSelectTimeThresholdAllTeam] = useState(false);
  const [isTimeThresholdTeamDropdownOpen, setIsTimeThresholdTeamDropdownOpen] = useState(false);
  const timeThresholdTeamDropdownRef = useRef(null);

  const [selectedBudgetThresholdTeamsEdit, setSelectedBudgetThresholdTeamsEdit] = useState([]);
  const [selectBudgetThresholdAllTeam, setSelectBudgetThresholdAllTeam] = useState(false);
  const [isBudgetThresholdTeamDropdownOpen, setIsBudgetThresholdTeamDropdownOpen] = useState(false);
  const budgetThresholdTeamDropdownRef = useRef(null);
  const [selectedProjectManagers, setSelectedProjectManagers] = useState([]);
  const [managerDropdownOpen, setManagerDropdownOpen] = useState(false);
  const managerDropdownRef = useRef(null);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [sprints, setSprints] = useState([]);
  const [totalHours, setTotalHours] = useState("");
  const [costBudget, setCostBudget] = useState("");
  const [sprint, setSprint] = useState("");
  const [sprintDiscription, setSprintDiscription] = useState("");

  const [projectNameIsValid, setProjectNameIsValid] = useState(false);
  const projectNameRef = useRef(null);
  const [clientIdIsValid, setClientIdIsValid] = useState(false);
  const clientIdRef = useRef(null);
  const clientDropdownRef = useRef(null);

  const [shouldFetchProject, setShouldFetchProject] = useState(false);

  const token = useSelector(
    (state) => state.auth.token
  )

  const { data: userId = [], isLoading: isUserLoading, refetch: refetchProjectManager } = useFetchClientProjectManager(token, clientId);
  const { data: clientName = [], isLoading: clientLoading, refetch: refetchClients } = useFetchClientDetails(token);
  const { data: allTeams = [], isLoading: teamLoading, isError: teamError } = useGetTeams(token);
  const teams = allTeams.filter(team => team.is_active === true);

  useEffect(() => {
    if (!hideButton || !isProjectModalOpen) return;
    const adminIds = teams
      .filter((team) => team.role_id === userType.Admin)
      .map((team) => team._id);
    if (!adminIds.length) return;
    setSelectedTimeThresholdTeamsEdit((current) => (current.length ? current : adminIds));
    setSelectedBudgetThresholdTeamsEdit((current) => (current.length ? current : adminIds));
  }, [hideButton, isProjectModalOpen, teams]);

  useEffect(() => {
    if (lockedClientId) setClientId(lockedClientId);
  }, [lockedClientId]);

  useEffect(() => {
    if (openSignal > 0) {
      setIsProjectModalOpen(true);
      if (lockedClientId) setClientId(lockedClientId);
      if (hideButton) {
        setTimeChecked(true);
        setBudgetChecked(true);
        setTimeThreshold((value) => (Number(value) > 0 ? value : 70));
        setBudgetThreshold((value) => (Number(value) > 0 ? value : 70));
      }
    }
  }, [openSignal, hideButton]);

  const handleOpenProjectModal = () => {
    setIsProjectModalOpen(true);
    setTimeThreshold(0);
    setSelectedTimeThresholdTeamsEdit([]);
    setBudgetThreshold(0);
    setSelectedBudgetThresholdTeamsEdit([]);
  };
  const handleCloseProjectModal = () => {
    setIsProjectModalOpen(false);
    setProjectName("");
    setClientId(lockedClientId || "");
    setDiscription("");
    setBillable(true);
    // setBudget("");
    setSelectedProjectManagers([]);
    // setTotalHours("");
    setSprint("");
    setTotalHours("");
    setCostBudget("");
    setDateRange(null);
    setSprintDiscription("");
    setProjectNameIsValid(false);
    setClientIdIsValid(false);
    setTimeThreshold(0);
    setSelectedTimeThresholdTeamsEdit([]);
    setBudgetThreshold(0);
    setSelectedBudgetThresholdTeamsEdit([]);
    setTimeChecked(false);
    setBudgetChecked(false);
    setIsSubmitLoading(false);
  };

  useEffect(() => {

    const radioLabels = document.querySelectorAll(".radio-option label");
    radioLabels.forEach((label) => {
      label.addEventListener("click", (e) => {
        const radioInput = label.previousElementSibling;
        radioInput.checked = true;
      });
    });
  }, [userId, clientId]);

  const projectManagerOptions = userId
    .slice()
    .sort((a, b) => {
      const nameA = a.first_name
        ? `${a.first_name} ${a.middle_name || ""} ${a.last_name}`
        : `${a.company_first_name ? a.company_first_name + (a.company_last_name && a.company_last_name) : a.company_name}`;
      const nameB = b.first_name
        ? `${b.first_name} ${b.middle_name || ""} ${b.last_name}`
        : `${b.company_first_name ? b.company_first_name + (b.company_last_name && b.company_last_name) : b.company_name}`;
      return nameA.localeCompare(nameB);
    })
    .map((item) => ({
      label: item.first_name ? `${item.first_name} ${item.middle_name || ""} ${item.last_name}` : (item.company_first_name ? `${item.company_first_name + (item.company_last_name && item.company_last_name)}` : `${item.company_name}(Company)`),
      value: item._id,
    }));

  const handleToggleClientDropdown = () => {
    setClientSearchTerm('');
    setClientDropdownOpen(!clientDropdownOpen);
  };

  const handleClientSearchInputChange = (e) => {
    setClientSearchTerm(e.target.value);
  };

  const filteredClients = clientName
    .filter((client) =>
      client.client_name.toLowerCase().includes(clientSearchTerm.toLowerCase())
    )
    .sort((a, b) =>
      a.client_name.toLowerCase().localeCompare(b.client_name.toLowerCase())
    );

  const dummyTeams = [
    { _id: "1", first_name: "John", last_name: "Doe", role_id: 1 },
    { _id: "2", first_name: "Jane", last_name: "Smith", role_id: 2 },
    { _id: "3", first_name: "Alice", last_name: "Brown", role_id: 3 },
    { _id: "4", first_name: "Bob", last_name: "Williams", role_id: 4 },
    { _id: "5", first_name: "Charlie", last_name: "Davis", role_id: 5 },
  ];

  const toggleDropdown = (type) => {
    if (type === "time") {
      setIsTimeThresholdTeamDropdownOpen(!isTimeThresholdTeamDropdownOpen);
    } else {
      setIsBudgetThresholdTeamDropdownOpen(!isBudgetThresholdTeamDropdownOpen);
    }
  };

  const toggleTimeThresholdTeamDropdown = () => {
    setIsTimeThresholdTeamDropdownOpen(!isTimeThresholdTeamDropdownOpen);
  };

  const handleTimeCheckboxChange = async () => {
    const newTimeChecked = !timeChecked;
    setTimeChecked(newTimeChecked);

    if (newTimeChecked) {
      if (timeThreshold === 0 && selectedTimeThresholdTeamsEdit.length === 0) {
        setTimeLoading(true);
        try {
          const response = await axios.post(
            "/api/general/thresholds/type",
            { thresholdType: "time" },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = response.data?.data;
          setTimeThreshold(data?.thresholdPercentage || 0);
          setSelectedTimeThresholdTeamsEdit(data?.alertTo || []);
        } catch (error) {
          console.error("Error fetching time threshold data:", error);
        } finally {
          setTimeLoading(false); // Stop loading
        }
      }
    } else {
      setTimeThreshold(timeThreshold);
      setSelectedTimeThresholdTeamsEdit(selectedTimeThresholdTeamsEdit);
    }
  };

  const handleBudgetCheckboxChange = async () => {
    const newBudgetChecked = !budgetChecked;
    setBudgetChecked(newBudgetChecked);

    if (newBudgetChecked) {
      if (budgetThreshold === 0 && selectedBudgetThresholdTeamsEdit.length === 0) {
        setBudgetLoading(true);
        try {
          const response = await axios.post(
            "/api/general/thresholds/type",
            { thresholdType: "budget" },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = response.data?.data;
          setBudgetThreshold(data?.thresholdPercentage || 0);
          setSelectedBudgetThresholdTeamsEdit(data?.alertTo || []);
        } catch (error) {
          console.error("Error fetching time threshold data:", error);
        } finally {
          setBudgetLoading(false); // Stop loading
        }
      }
    } else {
      setBudgetThreshold(budgetThreshold);
      setSelectedBudgetThresholdTeamsEdit(selectedBudgetThresholdTeamsEdit);
    }
  };

  const handleCheckboxTimeThresholdTeamChange = (teamId) => {
    const updatedSelection = [...selectedTimeThresholdTeamsEdit];
    const index = updatedSelection.indexOf(teamId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(teamId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }
    setSelectedTimeThresholdTeamsEdit(updatedSelection);
  };

  const handleSelectTimeThresholdAllTeamChange = () => {
    if (!selectTimeThresholdAllTeam) {
      setSelectedTimeThresholdTeamsEdit(teams.map((team) => team._id));
    } else {
      setSelectedTimeThresholdTeamsEdit([]);
    }
    setSelectTimeThresholdAllTeam(!selectTimeThresholdAllTeam);
  };

  const handleTimeThresholdSelectByRole = (role) => {
    const filteredUsers = teams.filter((team) => team.role_id === role).map((team) => team._id);
    setSelectedTimeThresholdTeamsEdit((prev) => {
      if (filteredUsers.every((id) => prev.includes(id))) {
        return prev.filter((id) => !filteredUsers.includes(id)); // Unselect if already selected
      } else {
        return [...new Set([...prev, ...filteredUsers])];
      }
    });
  };

  useEffect(() => {
    const updateSelectionStatus = () => {
      setSelectTimeThresholdAllTeam(selectedTimeThresholdTeamsEdit.length === teams.length);
    };

    // Call the updateSelectionStatus asynchronously
    Promise.resolve().then(() => updateSelectionStatus());
  }, [selectedTimeThresholdTeamsEdit, teams]);

  const toggleBudgetThresholdTeamDropdown = () => {
    setIsBudgetThresholdTeamDropdownOpen(!isBudgetThresholdTeamDropdownOpen);
  };

  const handleCheckboxBudgetThresholdTeamChange = (teamId) => {
    const updatedSelection = [...selectedBudgetThresholdTeamsEdit];
    const index = updatedSelection.indexOf(teamId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(teamId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }
    setSelectedBudgetThresholdTeamsEdit(updatedSelection);
  };

  const handleSelectBudgetThresholdAllTeamChange = () => {
    if (!selectBudgetThresholdAllTeam) {
      setSelectedBudgetThresholdTeamsEdit(teams.map((team) => team._id));
    } else {
      setSelectedBudgetThresholdTeamsEdit([]);
    }
    setSelectBudgetThresholdAllTeam(!selectBudgetThresholdAllTeam);
  };

  const handleBudgetThresholdSelectByRole = (role) => {
    const filteredUsers = teams.filter((team) => team.role_id === role).map((team) => team._id);
    setSelectedBudgetThresholdTeamsEdit((prev) => {
      if (filteredUsers.every((id) => prev.includes(id))) {
        return prev.filter((id) => !filteredUsers.includes(id)); // Unselect if already selected
      } else {
        return [...new Set([...prev, ...filteredUsers])];
      }
    });
  };

  useEffect(() => {
    const updateSelectionStatus = () => {
      setSelectBudgetThresholdAllTeam(selectedBudgetThresholdTeamsEdit.length === teams.length);
    };

    // Call the updateSelectionStatus asynchronously
    Promise.resolve().then(() => updateSelectionStatus());
  }, [selectedBudgetThresholdTeamsEdit, teams]);

  const handleSelectAllTeams = (type) => {
    if (type === "time") {
      if (selectTimeThresholdAllTeam) {
        setSelectedTimeThresholdTeamsEdit([]);
      } else {
        setSelectedTimeThresholdTeamsEdit(dummyTeams.map((team) => team._id));
      }
      setSelectTimeThresholdAllTeam(!selectTimeThresholdAllTeam);
    } else {
      if (selectBudgetThresholdAllTeam) {
        setSelectedBudgetThresholdTeamsEdit([]);
      } else {
        setSelectedBudgetThresholdTeamsEdit(dummyTeams.map((team) => team._id));
      }
      setSelectBudgetThresholdAllTeam(!selectBudgetThresholdAllTeam);
    }
  };

  const handleCheckboxChange = (teamId, type) => {
    if (type === "time") {
      setSelectedTimeThresholdTeamsEdit((prev) =>
        prev.includes(teamId) ? prev.filter((id) => id !== teamId) : [...prev, teamId]
      );
    } else {
      setSelectedBudgetThresholdTeamsEdit((prev) =>
        prev.includes(teamId) ? prev.filter((id) => id !== teamId) : [...prev, teamId]
      );
    }
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideClienDropdown = clientDropdownRef.current && clientDropdownRef.current.contains(event.target);
    const isClickInsideManagerDropdown = managerDropdownRef.current && managerDropdownRef.current.contains(event.target);
    const isClickInsideTimeThresholdTeamDropdown = timeThresholdTeamDropdownRef.current && timeThresholdTeamDropdownRef.current.contains(event.target);
    const isClickInsideBudgetThresholdTeamDropdown = budgetThresholdTeamDropdownRef.current && budgetThresholdTeamDropdownRef.current.contains(event.target);
    if (!isClickInsideClienDropdown) {
      setClientDropdownOpen(false);
    }
    if (!isClickInsideManagerDropdown) {
      setManagerDropdownOpen(false);
    }
    if (!isClickInsideTimeThresholdTeamDropdown) {
      setIsTimeThresholdTeamDropdownOpen(false);
    }
    if (!isClickInsideBudgetThresholdTeamDropdown) {
      setIsBudgetThresholdTeamDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  const handleProjectSubmit = async () => {
    setIsSubmitLoading(true);
    setProjectNameIsValid(false);
    setClientIdIsValid(false);

    if (projectName === "" || clientId === "") {
      if (projectName === "") {
        setProjectNameIsValid(true);
        projectNameRef.current.focus();
        setIsSubmitLoading(false);
        return;
      } else if (clientId === "") {
        setClientIdIsValid(true);
        clientIdRef.current.focus();
        clientIdRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        setIsSubmitLoading(false);
        return;
      }
      toast.error("Please fill all required fields", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    if (timeChecked) {
      if (timeThreshold <= 0) {
        toast.error("Time threshold must be greater than 0", {
          position: "bottom-right",
          autoClose: 2000,
        });
        setIsSubmitLoading(false);
        return;
      }

      if (!selectedTimeThresholdTeamsEdit || selectedTimeThresholdTeamsEdit.length === 0) {
        toast.error("Please select at least one team for time threshold alerts", {
          position: "bottom-right",
          autoClose: 2000,
        });
        setIsSubmitLoading(false);
        return;
      }
    }

    if (budgetChecked) {
      if (budgetThreshold <= 0) {
        toast.error("Budget threshold must be greater than 0", {
          position: "bottom-right",
          autoClose: 2000,
        });
        setIsSubmitLoading(false);
        return;
      }

      if (!selectedBudgetThresholdTeamsEdit || selectedBudgetThresholdTeamsEdit.length === 0) {
        toast.error("Please select at least one team for budget threshold alerts", {
          position: "bottom-right",
          autoClose: 2000,
        });
        setIsSubmitLoading(false);
        return;
      }
    }

    const requestData = {
      project_name: projectName.trim(),
      client_name: clientId,
      discription,
      is_billable: billable,
      project_manager: selectedProjectManagers.map((manager) => manager.value),
      ...(hideButton ? {
        total_hours: totalHours === "" ? undefined : Number(totalHours),
        budget: costBudget === "" ? undefined : Number(costBudget),
        start_date: dateRange?.[0] || null,
        end_date: dateRange?.[1] || null,
      } : {}),
    };

    const allSprints = [
      ...sprints,
      {
        sprint,
        sprintDiscription,
        sprintStartDate: null,
        sprintEndDate: null,
        id: Date.now(),
      },
    ];

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post("/api/project-details", {
        ...requestData,
        sprint: allSprints.map((obj) => obj.sprint),
        sprintDiscription: allSprints.map((obj) => obj.sprintDiscription),
        sprintStartDate: allSprints.map((obj) => obj.sprintStartDate),
        sprintEndDate: allSprints.map((obj) => obj.sprintEndDate),
      }, config);

      setSprints([]);
      setSprint("");

      if (response.status === 200) {
        const projectId = response.data?.id;

        if (timeChecked) {
          await axios.post("/api/project/sprint/threshold", {
            thresholdFor: "projects",
            recordId: projectId,
            clientId,
            thresholdType: "time",
            thresholdPercentage: timeThreshold,
            alertTo: selectedTimeThresholdTeamsEdit,
            thresholdTimeStatus: timeChecked,
          }, config);
        }

        if (budgetChecked) {
          await axios.post("/api/project/sprint/threshold", {
            thresholdFor: "projects",
            recordId: projectId,
            clientId,
            thresholdType: "budget",
            thresholdPercentage: budgetThreshold,
            alertTo: selectedBudgetThresholdTeamsEdit,
            thresholdBudgetStatus: budgetChecked,
          }, config);
        }

        if (!sprint) {
          toast.success("Project added successfully", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          global.config.activityLog(window.location.href, "Project", `Project (${projectName}) added Successfully`);
          dispatch(setProjectAdded());
          handleCloseProjectModal();
        } else {
          global.config.activityLog(window.location.href, "Project", `Project (${projectName}) and Sprints added Successfully`);
          toast.success("Project and sprint added successfully", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          handleCloseProjectModal();
        }
      } else {
        throw new Error("Failed to add project");
      }
    } catch (error) {
      console.error("Error adding project:", error);
      global.config.activityLog(window.location.href, "Project", `Failed to add Project (${projectName})`);
      toast.error("An error occurred while adding the project", {
        position: "bottom-right",
        autoClose: 2000,
      });
    } finally {
      setIsSubmitLoading(false);
      dispatch(setProjectAdded());
    }
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    setTimeout(() => {
      e.target.focus()
    }, 0)
  }


  const [dateRange, setDateRange] = useState(null);
  const [oneCalendar, setOneCalendar] = useState(() => window.innerWidth <= 991);

  useEffect(() => {
    const onResize = () => setOneCalendar(window.innerWidth <= 991);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleSelect = (value) => {
    if (value && value.length === 2) {
      const startDate = value[0];
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 2);
      setDateRange([startDate, endDate]);
    }
  };

  const alertRoleIds = (roleKey) => teams
    .filter((team) => team.role_id === userType[roleKey])
    .map((team) => team._id);

  const alertLabel = (selected) => {
    const match = ["Admin", "Super_Admin", "Project_Manager", "Team_Manager", "User"].find((role) => {
      const ids = alertRoleIds(role);
      return ids.length > 0 && ids.length === selected.length && ids.every((id) => selected.includes(id));
    });
    if (match === "Admin") return "All Admins";
    if (match === "Super_Admin") return "All Super Admin";
    if (match === "User") return "All Users";
    if (match) return `All ${match.replace("_", " ")}`;
    return selected.length ? "Selected" : "Select";
  };

  const alertOptions = [
    ["Admin", "All Admins"],
    ["Super_Admin", "All Super Admin"],
    ["Project_Manager", "All Project Manager"],
    ["Team_Manager", "All Team Manager"],
    ["User", "All Users"],
  ];

  const renderAlertSelect = (selected, setSelected, open, setOpen, ref) => (
    <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${open ? "open" : ""}`} ref={ref}>
      <div className="selected-option custom-dropdown-user-new" onClick={() => setOpen((value) => !value)}>
        {alertLabel(selected)}
      </div>
      {open && (
        <div className="custom-dropdown-new">
          <ul className="client-list">
            {alertOptions.map(([role, label]) => (
              <li
                key={role}
                onClick={() => {
                  setSelected(alertRoleIds(role));
                  setOpen(false);
                }}
              >
                {label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  return (

    <>
      {!hideButton && (
        <a className="new-client" onClick={handleOpenProjectModal}>
          <span className="icon-invoice">
            <img src={PlusIcon} alt="New Client" />
          </span>
          New Project
        </a>
      )}

      <Modal
        className={hideButton ? "mvp-new-project-modal" : "client-modal project-modal project-threshhold"}
        isOpen={isProjectModalOpen}
        onRequestClose={handleCloseProjectModal}
        contentLabel="New Project"
        style={hideButton ? {
          content: {
            width: "440px",
            maxWidth: "440px",
            height: "auto",
            maxHeight: "90vh",
            position: "relative",
            inset: "auto",
            overflow: "auto",
          },
        } : {
          content: {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "50%",
            left: "50%",
            parent: document.querySelector(".admin-outer.time.tracker"),
          },
        }}
      >
        {hideButton ? (
          <div className="mvp-np">
            <button type="button" className="mvp-np-close" onClick={handleCloseProjectModal} aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
                <path d="M1 1l12 12M13 1 1 13" stroke="#111" strokeWidth="1.4" />
              </svg>
            </button>
            <h2>New Project</h2>
            <label className="mvp-np-label">Client Name</label>
            <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${clientDropdownOpen ? "open" : ""}`} ref={clientDropdownRef}>
              <div
                className={`selected-option custom-dropdown-user-new ${clientId ? "" : "is-placeholder"}`}
                onClick={lockedClientId ? undefined : handleToggleClientDropdown}
              >
                {clientId ? (clientName.find((client) => client._id === clientId)?.client_name || "Select Client") : "Select Client"}
              </div>
              {clientDropdownOpen && (
                <div className="custom-dropdown-new">
                  <input
                    type="text"
                    className="search-bar"
                    placeholder="Search..."
                    value={clientSearchTerm}
                    onChange={handleClientSearchInputChange}
                  />
                  <ul className="client-list">
                    {filteredClients.map((client) => (
                      <li
                        key={client._id}
                        className={clientId === client._id ? "selected-item" : ""}
                        onClick={() => {
                          setClientId(client._id);
                          setClientDropdownOpen(false);
                        }}
                      >
                        {client.client_name}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <label className="mvp-np-label">Project Name</label>
            <input className="mvp-np-input" placeholder="Write here" value={projectName} onChange={(e) => setProjectName(e.target.value)} />
            <label className="mvp-np-label">Description</label>
            <textarea className="mvp-np-input mvp-np-area" value={discription} onChange={(e) => setDiscription(e.target.value)} />
            <label className="mvp-np-label">Time Allocated (in hours)</label>
            <input className="mvp-np-input" type="number" min="0" value={totalHours} onChange={(e) => setTotalHours(e.target.value)} onWheel={numberInputOnWheelPreventChange} />
            <label className="mvp-np-label">Cost Budget</label>
            <input className="mvp-np-input" type="number" min="0" value={costBudget} onChange={(e) => setCostBudget(e.target.value)} onWheel={numberInputOnWheelPreventChange} />
            <label className="mvp-np-label">Assign Project Manager</label>
            <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${managerDropdownOpen ? "open" : ""}`} ref={managerDropdownRef}>
              <div
                className={`selected-option custom-dropdown-user-new ${selectedProjectManagers[0] ? "" : "is-placeholder"}`}
                onClick={() => setManagerDropdownOpen((open) => !open)}
              >
                {isUserLoading ? "Loading..." : (selectedProjectManagers[0]?.label || "Select User")}
              </div>
              {managerDropdownOpen && (
                <div className="custom-dropdown-new">
                  <ul className="client-list">
                    {projectManagerOptions.map((option) => (
                      <li
                        key={option.value}
                        className={selectedProjectManagers[0]?.value === option.value ? "selected-item" : ""}
                        onClick={() => {
                          setSelectedProjectManagers([option]);
                          setManagerDropdownOpen(false);
                        }}
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <label className="mvp-np-label">Project Timeframe</label>
            <DateRangePicker
              className="mvp-np-range"
              value={dateRange}
              onChange={(value) => setDateRange(value)}
              format="MM/dd/yyyy"
              character=" to "
              placeholder="MM/DD/YYYY to MM/DD/YYYY"
              block
              cleanable={false}
              placement="bottomStart"
              showOneCalendar={oneCalendar}
              menuClassName="mvp-np-calendar"
              container={() => document.body}
              menuStyle={{
                position: "fixed",
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                transform: "translate(-50%, -50%)",
                zIndex: 200000,
                maxWidth: "calc(100vw - 32px)",
                maxHeight: "calc(100vh - 48px)",
                margin: 0,
              }}
              renderValue={(value) => {
                const fmt = (date) => {
                  const day = new Date(date);
                  const month = String(day.getMonth() + 1).padStart(2, "0");
                  const dateNum = String(day.getDate()).padStart(2, "0");
                  return `${month}/${dateNum}/${day.getFullYear()}`;
                };
                if (!value?.[0] || !value?.[1]) return null;
                return (
                  <span className="mvp-np-range-value">
                    <span>{fmt(value[0])}</span>
                    <span className="mvp-np-range-to">to</span>
                    <span>{fmt(value[1])}</span>
                  </span>
                );
              }}
            />
            <div className="mvp-np-alerts-title">Project Alerts</div>
            <label className="mvp-np-check">
              <input type="checkbox" checked={timeChecked} onChange={handleTimeCheckboxChange} />
              For time
            </label>
            <div className={`mvp-np-reach ${timeChecked ? "" : "is-off"}`}>
              <span>If project reaches</span>
              <span className="mvp-np-pct">
                <input type="number" min="0" max="100" value={timeThreshold} onChange={(e) => setTimeThreshold(e.target.value)} onWheel={numberInputOnWheelPreventChange} />
                <em>%</em>
              </span>
              <span>of estimate</span>
            </div>
            <div className={`mvp-np-alert-row ${timeChecked ? "" : "is-off"}`}>
              <span>Alert</span>
              {renderAlertSelect(selectedTimeThresholdTeamsEdit, setSelectedTimeThresholdTeamsEdit, isTimeThresholdTeamDropdownOpen, setIsTimeThresholdTeamDropdownOpen, timeThresholdTeamDropdownRef)}
            </div>
            <div className="mvp-np-divider" />
            <label className="mvp-np-check">
              <input type="checkbox" checked={budgetChecked} onChange={handleBudgetCheckboxChange} />
              For budget
            </label>
            <div className={`mvp-np-reach ${budgetChecked ? "" : "is-off"}`}>
              <span>If project reaches</span>
              <span className="mvp-np-pct">
                <input type="number" min="0" max="100" value={budgetThreshold} onChange={(e) => setBudgetThreshold(e.target.value)} onWheel={numberInputOnWheelPreventChange} />
                <em>%</em>
              </span>
              <span>of estimate</span>
            </div>
            <div className={`mvp-np-alert-row ${budgetChecked ? "" : "is-off"}`}>
              <span>Alert</span>
              {renderAlertSelect(selectedBudgetThresholdTeamsEdit, setSelectedBudgetThresholdTeamsEdit, isBudgetThresholdTeamDropdownOpen, setIsBudgetThresholdTeamDropdownOpen, budgetThresholdTeamDropdownRef)}
            </div>
            <button type="button" className="mvp-np-submit" onClick={handleProjectSubmit} disabled={isSubmitLoading}>
              {isSubmitLoading ? "Creating…" : "Create Project"}
            </button>
          </div>
        ) : (
          <div className="modal">
            <div className="modal-close-invite outter-modal-main">
              <a className="" onClick={handleCloseProjectModal}>
                <img src={crssrImage} alt="Edit Icon" />{" "}
              </a>
            </div>
            <div>
              <div className="modal-client-head">
                <h2 className="">New Project</h2>
              </div>
              <div className="form-field-client-outer">
                <form>
                  <div className="form-field-client">
                    <label htmlFor="projectName" className="form-label">
                      Project Name
                    </label>
                    <input
                      type="text"
                      id="projectName"
                      name="projectName"
                      value={projectName}
                      onChange={(e) => setProjectName(e.target.value)}
                      className={projectNameIsValid ? "input-validation-error form-input" : "form-input"}
                      ref={projectNameRef}
                    />
                    {projectNameIsValid && (
                      <span className="text-red-500 text-xs italic">
                        Project Name Field Cannot be empty
                      </span>
                    )}
                  </div>

                  <div className="form-field-client">
                    <label htmlFor="client" className="form-label">
                      Client Name
                    </label>

                    <div
                      className={`custom-dropdown-user-new-outer custom-dropdown-select ${clientDropdownOpen ? 'open' : ''
                        }`}
                      ref={clientDropdownRef}
                    >
                      <div
                        className="selected-option custom-dropdown-user-new"
                        onClick={handleToggleClientDropdown}
                        style={{ cursor: 'pointer' }}
                        ref={clientIdRef}
                      >
                        {clientId ? (
                          clientName.find((client) => client._id === clientId)?.client_name
                        ) : (
                          'Select'
                        )}
                      </div>
                      {clientDropdownOpen && (
                        <div className="custom-dropdown-new">
                          <input
                            type="text"
                            className="search-bar"
                            placeholder="Search..."
                            value={clientSearchTerm}
                            onChange={handleClientSearchInputChange}
                          />
                          <ul className="client-list">
                            {filteredClients.map((client) => (
                              <li
                                key={client._id}
                                className={clientId === client._id ? 'selected-item' : ''}
                                onClick={() => {
                                  setClientId(client._id);
                                  setClientDropdownOpen(false);
                                }}
                              >
                                {client.client_name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                    {clientIdIsValid && (
                      <span className="text-red-500 text-xs italic">
                        Client Name Field Cannot be empty
                      </span>
                    )}
                  </div>

                  <div className="form-field-client">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      value={discription}
                      onChange={(e) => setDiscription(e.target.value)}
                      className="form-textarea"
                      rows="3"
                    ></textarea>
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="projectManager" className="form-label">
                      Assigned team
                    </label>
                    {isUserLoading ? (
                      <div className="outter-load-table">
                        <ThreeDots
                          height="38"
                          width="40"
                          radius="9"
                          color="#6479f9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClassName=""
                          visible={true}
                        />
                      </div>
                    ) : (
                      <Select
                        isMulti
                        options={projectManagerOptions}
                        value={selectedProjectManagers}
                        onChange={(selectedOptions) => setSelectedProjectManagers(selectedOptions)}
                      />
                    )}
                  </div>
                  <div className="form-field-client radio-sec">
                    <label htmlFor="billable" className="form-label">
                      Billable
                    </label>
                    <div className="radio-container">
                      <div className="radio-option yes">
                        <input
                          type="radio"
                          id="yes"
                          name="billable"
                          value={billable}
                          checked={billable === true}
                          onChange={(e) => setBillable(true)}
                        />
                        <label htmlFor="yes">
                          Yes <img src={Tick} alt="Tick" />
                        </label>
                      </div>
                      <div className="radio-option no">
                        <input
                          type="radio"
                          id="no"
                          name="billable"
                          value={billable}
                          checked={billable === false}
                          onChange={(e) => setBillable(false)}
                        />
                        <label htmlFor="no">
                          No <img src={Close} alt="Edit Icon" />
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-field-client">
                    <label htmlFor="projectTimeframe" className="form-label">
                      Project Alerts
                    </label>
                    <div className="project-alert-outer">
                      {/* Time Alert */}

                      <div className="alert-section for-time-outer">
                        <label className="alert-label">
                          <input type="checkbox" checked={timeChecked} onChange={handleTimeCheckboxChange} />
                          <span>For time</span>
                        </label>

                        <div className={`outer-for-section ${!timeChecked ? "disabled" : ""}`}>
                          <div className="input-group">
                            <span>If project reaches</span>
                            {timeLoading ? (
                              <div className="outter-load-table">
                                <ThreeDots
                                  height="18"
                                  width="20"
                                  radius="9"
                                  color="#6479f9"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClassName=""
                                  visible={true}
                                />
                              </div>
                            ) : (
                              <input
                                type="number"
                                value={timeThreshold}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
                                    setTimeThreshold(value);
                                  }
                                }}
                                onWheel={numberInputOnWheelPreventChange}
                                min="0"
                                max="100"
                                step="1"
                              />
                            )}
                            <span>% of estimate</span>
                          </div>

                          <div className="dropdown-group">
                            <span>Alert</span>
                            <div className="custom-dropdown1" ref={timeThresholdTeamDropdownRef}>
                              <div className="drop-down-inner" onClick={toggleTimeThresholdTeamDropdown}>
                                <div className="selected-options1">
                                  {selectedTimeThresholdTeamsEdit.length === 0 ? (
                                    <div className="placeholder">Select</div>
                                  ) : (
                                    <>
                                      <div className="selected-option1">
                                        {timeLoading ? (
                                          <div className="outter-load-table">
                                            <ThreeDots
                                              height="18"
                                              width="20"
                                              radius="9"
                                              color="#6479f9"
                                              ariaLabel="three-dots-loading"
                                              wrapperStyle={{}}
                                              wrapperClassName=""
                                              visible={true}
                                            />
                                          </div>
                                        ) : (() => {
                                          const roles = {
                                            Super_Admin: "All Super Admin",
                                            Admin: "All Admin",
                                            Project_Manager: "All Project Manager",
                                            Team_Manager: "All Team Manager",
                                            User: "All Users",
                                          };

                                          // Check if all users of a specific role are selected
                                          for (const [roleKey, roleLabel] of Object.entries(roles)) {
                                            const roleUsers = teams
                                              .filter((team) => team.role_id === userType[roleKey])
                                              .map((team) => team._id);

                                            if (
                                              roleUsers.length > 0 &&
                                              roleUsers.every((id) => selectedTimeThresholdTeamsEdit.includes(id)) &&
                                              selectedTimeThresholdTeamsEdit.length === roleUsers.length
                                            ) {
                                              return roleLabel;
                                            }
                                          }

                                          // If all team members are selected
                                          if (selectedTimeThresholdTeamsEdit.length === teams.length) {
                                            return "All Team";
                                          }

                                          // Get the first selected user name
                                          const firstSelectedUser =
                                            teams.find((item) => item._id === selectedTimeThresholdTeamsEdit[0])
                                              ? (() => {
                                                const user = teams.find((item) => item._id === selectedTimeThresholdTeamsEdit[0]);

                                                return user.first_name
                                                  ? `${user.first_name} ${user.middle_name || ""} ${user.last_name}`.trim()
                                                  : `${user.company_first_name ? user.company_first_name + (user.company_last_name ? " " + user.company_last_name : "") : user.company_name}`;
                                              })()
                                              : "No Users selected";

                                          return (
                                            <>
                                              {firstSelectedUser}
                                              {selectedTimeThresholdTeamsEdit.length > 1 && (
                                                <div className="selected-option-count">
                                                  {selectedTimeThresholdTeamsEdit.length - 1}+
                                                </div>
                                              )}
                                            </>
                                          );
                                        })()}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              {isTimeThresholdTeamDropdownOpen && (
                                <div className="dropdown-list1">
                                  <label className="checkbox-label1" key="selectAll">
                                    <input
                                      type="checkbox"
                                      checked={selectTimeThresholdAllTeam}
                                      onChange={handleSelectTimeThresholdAllTeamChange}
                                    />
                                    All Teams
                                  </label>
                                  {["Super_Admin", "Admin", "Project_Manager", "Team_Manager", "User"]
                                    .filter((role) => teams.some((team) => team.role_id === userType[role]))
                                    .map((role) => (
                                      <label className="checkbox-label1" key={role}>
                                        <input
                                          type="checkbox"
                                          checked={teams
                                            .filter((team) => team.role_id === userType[role])
                                            .every((team) => selectedTimeThresholdTeamsEdit.includes(team._id))}
                                          onChange={() => handleTimeThresholdSelectByRole(userType[role])}
                                        />
                                        All {role.replace("_", " ")}
                                      </label>
                                    ))}
                                  {teams.map((team) => (
                                    <label className="checkbox-label1" key={team._id}>
                                      <input
                                        type="checkbox"
                                        checked={selectedTimeThresholdTeamsEdit.includes(team._id)}
                                        onChange={() => handleCheckboxTimeThresholdTeamChange(team._id)}
                                      />
                                      {team.first_name ? `${team.first_name} ${team.middle_name || ""} ${team.last_name}`.trim() : `${team.company_first_name ? team.company_first_name + (team.company_last_name ? " " + team.company_last_name : "") : team.company_name}`}
                                    </label>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Budget Alert */}
                      <div className="alert-section for-budget-outer">
                        <label className="alert-label">
                          <input type="checkbox" checked={budgetChecked} onChange={handleBudgetCheckboxChange} />
                          <span>For budget</span>
                        </label>

                        <div className={`outer-for-section ${!budgetChecked ? "disabled" : ""}`}>
                          <div className="input-group">
                            <span>If project reaches</span>
                            {budgetLoading ? (
                              <div className="outter-load-table">
                                <ThreeDots
                                  height="18"
                                  width="20"
                                  radius="9"
                                  color="#6479f9"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClassName=""
                                  visible={true}
                                />
                              </div>
                            ) : (
                              <input
                                type="number"
                                value={budgetThreshold}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
                                    setBudgetThreshold(value);
                                  }
                                }}
                                onWheel={numberInputOnWheelPreventChange}
                                min="0"
                                max="100"
                                step="1"
                              />
                            )}
                            <span>% of estimate</span>
                          </div>

                          <div className="dropdown-group">
                            <span>Alert</span>
                            <div className="custom-dropdown1" ref={budgetThresholdTeamDropdownRef}>
                              <div className="drop-down-inner" onClick={toggleBudgetThresholdTeamDropdown}>
                                <div className="selected-options1">
                                  {selectedBudgetThresholdTeamsEdit.length === 0 ? (
                                    <div className="placeholder">Select</div>
                                  ) : (
                                    <>
                                      <div className="selected-option1">
                                        {selectedBudgetThresholdTeamsEdit.length === 0 ? (
                                          <div className="placeholder">Select</div>
                                        ) : (
                                          <>
                                            <div className="selected-option1">
                                              {budgetLoading ? (
                                                <div className="outter-load-table">
                                                  <ThreeDots
                                                    height="18"
                                                    width="20"
                                                    radius="9"
                                                    color="#6479f9"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClassName=""
                                                    visible={true}
                                                  />
                                                </div>
                                              ) : (() => {
                                                const roles = {
                                                  Super_Admin: "All Super Admin",
                                                  Admin: "All Admin",
                                                  Project_Manager: "All Project Manager",
                                                  Team_Manager: "All Team Manager",
                                                  User: "All Users",
                                                };

                                                // Check if all users of a specific role are selected
                                                for (const [roleKey, roleLabel] of Object.entries(roles)) {
                                                  const roleUsers = teams
                                                    .filter((team) => team.role_id === userType[roleKey])
                                                    .map((team) => team._id);

                                                  if (
                                                    roleUsers.length > 0 &&
                                                    roleUsers.every((id) => selectedBudgetThresholdTeamsEdit.includes(id)) &&
                                                    selectedBudgetThresholdTeamsEdit.length === roleUsers.length
                                                  ) {
                                                    return roleLabel;
                                                  }
                                                }

                                                // If all team members are selected
                                                if (selectedBudgetThresholdTeamsEdit.length === teams.length) {
                                                  return "All Team";
                                                }

                                                // Get the first selected user name
                                                const firstSelectedUser =
                                                  teams.find((item) => item._id === selectedBudgetThresholdTeamsEdit[0])
                                                    ? (() => {
                                                      const user = teams.find((item) => item._id === selectedBudgetThresholdTeamsEdit[0]);

                                                      return user.first_name
                                                        ? `${user.first_name} ${user.middle_name || ""} ${user.last_name}`.trim()
                                                        : `${user.company_first_name ? user.company_first_name + (user.company_last_name ? " " + user.company_last_name : "") : user.company_name}`;
                                                    })()
                                                    : "No Users selected";

                                                return (
                                                  <>
                                                    {firstSelectedUser}
                                                    {selectedBudgetThresholdTeamsEdit.length > 1 && (
                                                      <div className="selected-option-count">
                                                        {selectedBudgetThresholdTeamsEdit.length - 1}+
                                                      </div>
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              {isBudgetThresholdTeamDropdownOpen && (
                                <div className="dropdown-list1">
                                  <label className="checkbox-label1" key="selectAll">
                                    <input
                                      type="checkbox"
                                      checked={selectBudgetThresholdAllTeam}
                                      onChange={handleSelectBudgetThresholdAllTeamChange}
                                    />
                                    All Teams
                                  </label>
                                  {["Super_Admin", "Admin", "Project_Manager", "Team_Manager", "User"]
                                    .filter((role) => teams.some((team) => team.role_id === userType[role]))
                                    .map((role) => (
                                      <label className="checkbox-label1" key={role}>
                                        <input
                                          type="checkbox"
                                          checked={teams
                                            .filter((team) => team.role_id === userType[role])
                                            .every((team) => selectedBudgetThresholdTeamsEdit.includes(team._id))}
                                          onChange={() => handleBudgetThresholdSelectByRole(userType[role])}
                                        />
                                        All {role.replace("_", " ")}
                                      </label>
                                    ))}
                                  {teams.map((team) => (
                                    <label className="checkbox-label1" key={team._id}>
                                      <input
                                        type="checkbox"
                                        checked={selectedBudgetThresholdTeamsEdit.includes(team._id)}
                                        onChange={() => handleCheckboxBudgetThresholdTeamChange(team._id)}
                                      />
                                      {team.first_name ? `${team.first_name} ${team.middle_name || ""} ${team.last_name}`.trim() : `${team.company_first_name ? team.company_first_name + (team.company_last_name ? " " + team.company_last_name : "") : team.company_name}`}
                                    </label>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {isSubmitLoading ?
                    (
                      <div className="outter-load-table">
                        <ThreeDots
                          height="38"
                          width="40"
                          radius="9"
                          color="#6479f9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClassName=""
                          visible={true}
                        />
                      </div>
                    ) : (
                      <button type="button" onClick={handleProjectSubmit} className="submit-client">
                        Create Project
                      </button>
                    )}
                </form>
              </div>
            </div>

          </div>
        )}
      </Modal>

    </>
  )
}

export default NewProjectsModal;